import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddShippingRate({ open, onClose, setOpen }: ModalProps) {
    const [rateType, setRateType] = useState("Flat Rate");
    const [active, setActive] = useState(true);

    const handleRateTypeChange = (event: SelectChangeEvent) => {
        setRateType(event.target.value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Shipping Rate</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            {/* Rate Name */}
                            <div className="control_group w_50">
                                <label htmlFor="rate-name">Rate Name</label>
                                <TextField
                                    placeholder="Standard Shipping"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "rate-name" }}
                                />
                            </div>

                            {/* Carrier */}
                            <div className="control_group w_50">
                                <label htmlFor="shipping-carrier">Carrier</label>
                                <TextField
                                    placeholder="Aramex, FedEx, etc."
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "shipping-carrier" }}
                                />
                            </div>

                            {/* Rate Type */}
                            <div className="control_group">
                                <label htmlFor="rate-type">Rate Type</label>
                                <Select
                                    fullWidth
                                    value={rateType}
                                    onChange={handleRateTypeChange}
                                    inputProps={{ id: "rate-type" }}
                                >
                                    <MenuItem value="Flat Rate">
                                        Flat Rate
                                    </MenuItem>
                                    <MenuItem value="Weight Based">
                                        Weight Based
                                    </MenuItem>
                                </Select>
                            </div>

                            {/* Base Rate */}
                            <div className="control_group w_50">
                                <label htmlFor="base-rate">Base Rate (fils)</label>
                                <TextField
                                    type="number"
                                    placeholder="0"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "base-rate" }}
                                />
                            </div>

                            {/* Per KG Rate */}
                            <div className="control_group w_50">
                                <label htmlFor="per-kg-rate">Per KG Rate (fils)</label>
                                <TextField
                                    type="number"
                                    placeholder="0"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "per-kg-rate" }}
                                />
                            </div>

                            {/* Free Shipping Threshold */}
                            <div className="control_group">
                                <label htmlFor="free-shipping-threshold">Free Shipping Threshold (fils)</label>
                                <TextField
                                    type="number"
                                    placeholder="0"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "free-shipping-threshold" }}
                                />
                                <small>
                                    Orders above this amount get free shipping
                                </small>
                            </div>

                            {/* Active */}
                            <div className="control_group">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={active}
                                            onChange={(e) =>
                                                setActive(e.target.checked)
                                            }
                                        />
                                    }
                                    label="Active"
                                />
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Create
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
